module.exports = __webpack_public_path__ + "static/media/PopUpImage.4e31af7e.png";